<template>
  <div :class="wrapperClasses">
    <div class="listing">
      <b-button @click="addNew" class="float-right" icon-left="plus" rounded>Add new user</b-button>
      <b-table :data="items" :row-class="(row, index) => assignRowClasses(row, index)">
        <template slot-scope="props">
          <b-table-column field="fulltName" label="first / last names" sortable>
            <a
              :href="props.row.identifier|mailto"
              :title="props.row.email|mailTooltip"
            >{{props.row.fullName}}</a>
          </b-table-column>
          <b-table-column field="active" class="check-column" label="Active" sortable>
            <b-icon v-if="props.row.active" icon="check" size="is-small " />
          </b-table-column>
          <b-table-column field="role" class="check-column" label="Role" sortable>{{props.row.role|toWords}}</b-table-column>
          <b-table-column
            field="createdAt"
            class="check-column"
            label="Joined"
            sortable
          >{{props.row.createdAt|shortDate}}</b-table-column>
          <b-table-column
            field="modifiedAt"
            class="check-column"
            label="Updated"
            sortable
          >{{props.row.modifiedAt|shortDate}}</b-table-column>
          <b-table-column field="exit" class="check-column" label="Edit" sortable>
            <span class="edit" v-on:click="showUser(props.row._id)">
              <b-icon icon="square-edit-outline" />
            </span>
          </b-table-column>
        </template>
      </b-table>
      <b-button @click="addNew" class="float-right" icon-left="plus" rounded>Add new user</b-button>
    </div>
    <UserDetail v-if="showDetail" :user="user" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { listAdmins } from "../api/methods";
import { mapUser } from "../api/mappers";
import filters from "../mixins/filters";
import { userSchema } from "../store/schemas";
import UserDetail from "./UserDetail";

export default {
  name: "UserList",
  components: {
    UserDetail
  },
  mixins: [filters],
  data() {
    return {
      items: [],
      num: 0,
      total: 0,
      criteria: {},
      perPage: 100,
      start: 0,
      showDetail: false,
      user: userSchema
    };
  },
  computed: {
    ...mapGetters(["settings", "options", "countries"]),
    wrapperClasses() {
      let cls = ["submissions"];
      if (this.showDetail) {
        cls.push("show-detail");
      }
      return cls;
    },
    computed() {
      return this.items.length;
    }
  },
  created() {
    this.loadAdminUsers();
  },
  methods: {
    showUser(id) {
      let user = null;
      if (id === "new") {
        user = userSchema;
        user._id = "new";
        user.active = true;
        user.role = "selector";
      } else {
        user = this.items.find(sub => sub._id === id);
      }
      if (user instanceof Object) {
        if (user._id) {
          this.user = user;
          this.showDetail = true;
          const newPath = "/users/" + id;
          if (this.$route.path !== newPath) {
            this.$router.push(newPath);
          }
        }
      }
    },
    close() {
      this.showDetail = false;
      const newPath = "/users";
      if (this.$route.path !== newPath) {
        this.$router.push(newPath);
      }
    },
    assignRowClasses(row, index) {
      let cls = [];
      if (index % 2 === 0) {
        cls.push("even");
      }
      if (row.active) {
        cls.push("active");
      }
      return cls.join(" ");
    },
    addNew() {
      this.showUser("new");
    },
    update() {
      this.loadAdminUsers();
      this.close();
    },
    loadAdminUsers() {
      listAdmins().then(data => {
        if (data.items instanceof Array) {
          this.items = data.items.map(mapUser);
        }
      });
    }
  }
};
</script>